import React from 'react'
import "./React-tables.css"


class Footer extends React.Component{
render(){
    return(
<footer id="footer">
<ul className="icons">
    <li><a href="https://www.instagram.com/uob.notes/" className="icon brands fa-instagram"><span className="label">Instagram</span></a></li>
    
</ul>
<a href="/termsofservice" >Terms of Service </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<a href="/privacypolicy" >Privacy Policy</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<a href="/contactus" >Contact Us</a>
<ul className="copyright">
    <li>&copy; 2020 UOB Notes. All Rights Reserved. </li>
</ul>
</footer>
    );}

}

    export default Footer